import React, { useState, useRef } from 'react';
import { motion } from 'framer-motion';
interface MagneticProps {
  children: React.ReactNode;
  className?: string;
  strength?: number; // How strong the magnetic pull is (default: 0.5)
}
export function Magnetic({
  children,
  className = '',
  strength = 0.5
}: MagneticProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [position, setPosition] = useState({
    x: 0,
    y: 0
  });
  const handleMouse = (e: React.MouseEvent<HTMLDivElement>) => {
    const {
      clientX,
      clientY
    } = e;
    const {
      height,
      width,
      left,
      top
    } = ref.current?.getBoundingClientRect() || {
      height: 0,
      width: 0,
      left: 0,
      top: 0
    };
    const middleX = clientX - (left + width / 2);
    const middleY = clientY - (top + height / 2);
    setPosition({
      x: middleX * strength,
      y: middleY * strength
    });
  };
  const reset = () => {
    setPosition({
      x: 0,
      y: 0
    });
  };
  const {
    x,
    y
  } = position;
  return <motion.div ref={ref} className={className} onMouseMove={handleMouse} onMouseLeave={reset} animate={{
    x,
    y
  }} transition={{
    type: 'spring',
    stiffness: 150,
    damping: 15,
    mass: 0.1
  }} data-id="element-195">
      {children}
    </motion.div>;
}